"use client";

import { Core } from "@faire/design-tokens";
import React from "react";

import { createSVGIcon } from "../util";

/** @deprecated `@faire/slate/icons/Cheese` instead */
export const Cheese = createSVGIcon(
  <>
    <path
      d="M15.726 1.034 15.57 1 1.43 9.331A.8.8 0 0 0 1 10v11.503a.857.857 0 0 0 .857.857H22.43a.857.857 0 0 0 .857-.857v-12a10.08 10.08 0 0 0-7.56-8.469ZM1.154 9.571H22.43"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="m1 17.577.137-.12a3.43 3.43 0 0 1 2.434-1.028A3.43 3.43 0 0 1 7 19.857a3.43 3.43 0 0 1-1.011 2.417l-.138.155M15.571 18.143a2.572 2.572 0 1 0 0-5.143 2.572 2.572 0 0 0 0 5.143Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </>,
  "Cheese",
  { color: Core.icon.default, fill: "none", viewBox: "0 0 24 24" } // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
